import React, { useState, useReducer } from "react";
import { useDispatch } from "react-redux";
import { setMessageHandler } from "../../../reducers/selectedValues";
import { Box } from "@mui/material";
import { InputText } from "../../uiControls/inputText";
import useHttpRequests from "../../../hooks/useHttpRequests";
import { MessageDisplay } from "../../common/messageDisplay";
import { SaveCancel } from "../../uiControls/saveCancel";
import { StatusControl } from "../../uiControls/statusControl";
import { FileTypeColumnAdd } from "./fileTypeColumnAdd";
import * as utils from "../../common/utils";

const initialFileTypeIsValid = {
  name: "",
  description: "",
  fileColumns: "",
};

export const FileTypeAdd = (props) => {
  const { setUpdateOpen, fileTypeEdit, setFileTypeEdit, fileTypeAttributes } =
    props;
  const messageDispatch = useDispatch();
  const { sendRequest: addFileType } = useHttpRequests();
  const [selectedRows, setSelectedRows] = useState([]);

  const [fileTypeDetails, setFileTypeDetails] = useReducer(
    (state, updates) => ({ ...state, ...updates }),
    fileTypeAttributes
  );

  const [isValid, setIsValid] = useReducer(
    (state, updates) => ({ ...state, ...updates }),
    initialFileTypeIsValid
  );

  const updateFileTypeDetailsValue = (_key, value) => {
    setFileTypeDetails({ [_key]: value });
    if (value) {
      updateErrorMessage([_key], "", "");
    }
  };

  const updateErrorMessage = (_key, header, errMsg) => {
    setIsValid({ [_key]: errMsg + header });
  };

  const onChangeHandler = (e, controlName) => {
    updateFileTypeDetailsValue(
      controlName,
      e.target.type === "checkbox" ? e.target.checked : e.target.value
    );
  };
  const cancelFileTypeHandler = () => {
    messageDispatch(setMessageHandler({ type: null, message: null }));
    setFileTypeEdit(false);
    setUpdateOpen(false);
  };

  const validateFileTypeDetails = () => {
    setIsValid(initialFileTypeIsValid);

    var errorSummary = "";

    if (!fileTypeDetails.name) {
      updateErrorMessage("name", "File type", "Enter ");
      errorSummary += "Enter file type \n";
    } else if (!utils.isValidCharacters(fileTypeDetails.name)) {
      updateErrorMessage("name", "File type", " has restricted characters");
      errorSummary += "File type has restricted characters \n";
    }

    if (!fileTypeDetails.description) {
      updateErrorMessage("description", "File type description", "Enter ");
      errorSummary += "Enter file type description \n";
    } else if (!utils.isValidCharacters(fileTypeDetails.description)) {
      updateErrorMessage(
        "description",
        "File type Description",
        " has restricted characters"
      );
      errorSummary += "File type description has restricted characters \n";
    }

    if (selectedRows?.length <= 0) {
      updateErrorMessage("fileColumns", "Column mappings required", "Enter ");
      errorSummary += "A filetype must have atleast one active column. \n";
    } else if (
      selectedRows?.filter((item) => item.columnNumber === "")?.length > 0
    ) {
      updateErrorMessage(
        "fileColumns",
        "Column numbers are required",
        "Enter "
      );
      errorSummary += "Missing column number \n";
    } else if (utils.findDuplicates(selectedRows, "columnNumber")?.length > 0) {
      updateErrorMessage("fileColumns", "Duplicate column numbers", "Enter ");
      errorSummary += "Column number must be unique \n";
    }

    if (errorSummary !== "") {
      messageDispatch(
        setMessageHandler({ type: "error", message: errorSummary })
      );
    } else {
      let dataObj = fileTypeDetails;
      dataObj["fileColumns"] = selectedRows?.map((c) => {
        return {
          columnKey: c.columnKey,
          columnNumber: c.columnNumber,
          active: c.active,
          phi: c.phi,
        };
      });

      const getUpdateFileTypeResponse = (resObj) => {
        if (
          !resObj ||
          !resObj["isSuccess"] ||
          (resObj["validationErrors"] !== undefined &&
            resObj["validationErrors"]?.length > 0)
        ) {
          messageDispatch(
            setMessageHandler({
              type: "error",
              message:
                (resObj["message"] ? resObj["message"] : "") +
                (resObj["validationErrors"]?.length > 0
                  ? "\n" + resObj["validationErrors"]?.join("\n")
                  : ""),
            })
          );
          return;
        }
        messageDispatch(
          setMessageHandler({
            type: "success",
            message: "File type updated successfully!",
          })
        );
        setTimeout(() => {
          cancelFileTypeHandler();
        }, 2000);
      };

      delete dataObj["fileTypeKey"];
      addFileType(
        { url: "FileTypes", body: dataObj },
        getUpdateFileTypeResponse
      );
    }
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          width: "100%",
          overflow: "hidden",
          padding: "0px",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            overflow: "auto",
          }}
        >
          <MessageDisplay />
          <InputText
            type="text"
            label="File Type"
            id={"fileTypeDetails.name"}
            value={fileTypeDetails.name}
            onChange={(e) => onChangeHandler(e, "name")}
            isRequired={true}
            isError={isValid["name"] !== ""}
            charLength={50}
          />
          <InputText
            type="text"
            label="Description"
            id={"fileTypeDetails.description"}
            value={fileTypeDetails.description}
            onChange={(e) => onChangeHandler(e, "description")}
            isRequired={true}
            isError={isValid["description"] !== ""}
            charLength={50}
          />

          {/*<StatusControl
            label="Active"
            isRequired={false}
            fieldName={"active"}
            active={fileTypeDetails.active}
            updateStatusValue={updateFileTypeDetailsValue}
        />*/}

          <FileTypeColumnAdd setSelectedRows={setSelectedRows} />

          <SaveCancel
            cancelCall={() => cancelFileTypeHandler()}
            saveCall={() => validateFileTypeDetails()}
          />
        </div>
      </Box>
    </>
  );
};
